import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconChevronUp({ outlineWidth, strokeWidth, stroke, fill, ...otherProps }){
    return (
        <IconChevronUp.Svg
            viewBox="0 0 62 62"
            fill="none"
            fillRule="evenodd"
            outlineWidth={outlineWidth}
            strokeWidth={strokeWidth}
            strokeColour={stroke}
            fillColour={fill}
            {...otherProps}
        >
            <circle
                cx="31"
                cy="31"
                r="30"
            />
            <path
                fill="none"
                d="M19.5 35.5L32 23.5L44.5 35.5"
            />
        </IconChevronUp.Svg>
    );
}

IconChevronUp.propTypes = {
    outlineWidth: PropTypes.string,
    strokeWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

IconChevronUp.defaultProps = {
    outlineWidth: '2px',
    strokeWidth: '2px',
    stroke: Colours.BLACKBERRY,
    fill: Colours.TRANSPARENT,
};

IconChevronUp.Svg = styled.svg`
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    circle {
        stroke-width: ${props => props.outlineWidth};
    }

    transition:
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconChevronUp;

